import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  padding: 0 8px;
`
